(function ($, njm) {
    'use strict';

    njm.views.microTestimonials = Backbone.View.extend({

        events: {
            'click .start-button': 'onStartButtonClick',
            'click .stop-button': 'onStopButtonClick',
            'click .comp-micro-video': 'onVideoClick'
        },

        /**
         * Initialize
         */
        initialize: function () {
            var $videos = this.$el.find('.video-container');

            $(window).scroll(function () {
                $videos.each(function (index, elem) {
                    if (!this.isScrolledIntoView(index, elem)) {
                        var wistiaId = $(elem).find('.comp-micro-video').attr('wistia-id');
                        window['wistia_' + wistiaId].pause();
                        $(elem).find('.start-button').removeClass('hide');
                        $(elem).find('.stop-button').addClass('hide');
                    }
                }.bind(this));

                var visibleVideo = $videos.filter(this.isScrolledIntoView)[0];
                if (visibleVideo) {
                    var wistiaId = $(visibleVideo).find('.comp-micro-video').attr('wistia-id');
                    window['wistia_' + wistiaId].play();
                    $(visibleVideo).find('.start-button').addClass('hide');
                    $(visibleVideo).find('.stop-button').removeClass('hide');
                }
            }.bind(this));
        },

        /**
         * isScrolledIntoView
         * @param index
         * @param elem
         * @return {boolean}
         */
        isScrolledIntoView: function (index, elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        },

        /**
         * On start button click
         * @param ev
         */
        onStartButtonClick: function (ev) {
            var $this = $(ev.currentTarget);
            var $videoContainer = $this.closest('.video-container');
            var wistiaId = $videoContainer.find('.comp-micro-video').attr('wistia-id');
            window['wistia_' + wistiaId].play();
            $this.addClass('hide');
            $videoContainer.find('.stop-button').removeClass('hide');
        },

        /**
         * On stop button click
         * @param ev
         */
        onStopButtonClick: function (ev) {
            var $this = $(ev.currentTarget);
            var $videoContainer = $this.closest('.video-container');
            var wistiaId = $videoContainer.find('.comp-micro-video').attr('wistia-id');
            window['wistia_' + wistiaId].pause();
            $this.addClass('hide');
            $videoContainer.find('.start-button').removeClass('hide');
        },

        /**
         * On video click
         * @param ev
         */
        onVideoClick: function (ev) {
            var $this = $(ev.currentTarget);
            var $videoContainer = $this.closest('.video-container');
            var wistiaId = $videoContainer.find('.comp-micro-video').attr('wistia-id');
            if (window['wistia_' + wistiaId].state() === 'paused') {
                $videoContainer.find('.start-button').removeClass('hide');
                $videoContainer.find('.stop-button').addClass('hide');
            } else {
                $videoContainer.find('.start-button').addClass('hide');
                $videoContainer.find('.stop-button').removeClass('hide');
            }
        }
    });
})(jQuery, njm);
